<template>
	<footer id="footer">
		<div class="container">
			<p class="ftr-txt1">
				<a href="https://priceshopinsurance.com/privacy-policy/"
					>Privacy Policy</a
				>|<a href="https://priceshopinsurance.com/terms-and-conditions/"
					>Terms and Conditions</a
				><span class="hide-mob">|</span><br class="forMob" /><a
					href="https://priceshopinsurance.com/ccpa-privacy-policy/"
					>CCPA</a
				>|<a href="https://priceshopinsurance.com/ccpa-opt-out/"
					>Opt Out Form</a
				>
			</p>
			<p class="ftr-txt1">
				© 2021 PriceShopInsurance.com. All Rights Reserved.
			</p>
			<p class="ftr-txt2">
				PriceShopInsurance is a leading online marketplace connecting
				consumers with insurance carriers and agencies, and we do not
				provide quotes directly to consumers. Price Shop Insurance does
				not provide insurance nor are we a licensed insurance provider.
				The lowest advertised rates are not necessarily available from
				all advertisers on our site. PriceShopInsurance matches users to
				advertisers and insurance agents only after we've received
				specific information from you, noting that your rates may vary
				based on your coverage limits, deductibles, driving history,
				occupation, education, type of vehicle, and location, among
				other pre-determined factors.
			</p>
		</div>
	</footer>
</template>

<script>
export default {};
</script>